<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<div class="grid fluid">

  <div class="col-4">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 1" [(ngModel)]="allowImpStock" class="mb-2" (onChange)="onA1StockSelectionChange($event)"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowImpStock" [selectedID]="stock1" (selectedDepartmentID)="onA1Stock1Selected($event)"></app-departmentselector>
  </div>
  <div class="col-4">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 2" [(ngModel)]="allowAuxStock" class="mb-2" (onChange)="onA1StockSelectionChange($event)"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowAuxStock" [selectedID]="stock2" (selectedDepartmentID)="onA1Stock2Selected($event)"></app-departmentselector>
  </div>
  <div class="col-4">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 3" [(ngModel)]="allowCmpStock" class="mb-2" (onChange)="onA1StockSelectionChange($event)"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowCmpStock" [selectedID]="stock3" (selectedDepartmentID)="onA1Stock3Selected($event)"></app-departmentselector>
  </div>
</div>
